import { Component, OnInit, Input } from '@angular/core';

import { ViewCell } from '@app/shared/smart-table/ng2-smart-table';

@Component({
  standalone: false,
  selector: 'app-boolean-format',
  template: `
    {{ renderValue }}
  `
})
export class BooleanFormatComponent implements OnInit, ViewCell {
  @Input() value: any;
  @Input() rowData: any;

  public renderValue: string;

  ngOnInit() {
    if (this.value === true) {
      this.renderValue = 'Sí';
    } else {
      this.renderValue = 'No';
    }
  }
}
